import {createEvent} from "./createEvent";

export const pageEvents = {
    scroll: createEvent<number>(),
    // scroll: createEvent<{
    //     x: number;
    //     y: number;
    // }>(),
    scrollToReviews: createEvent(),
    scrollToMap: createEvent(),
};
